import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CmsParagraphComponent } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
@Component({
    selector: 'app-profile-external-paragraph',
    templateUrl: './profile-external-paragraph.component.html',
    styleUrl: './profile-external-paragraph.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ProfileExternalParagraphComponent implements OnInit{
  public componentData: CmsParagraphComponent;
  constructor(public component: CmsComponentData<CmsParagraphComponent>) { }
  ngOnInit(): void {
    // this.getUserRole();
    this.component.data$.subscribe((data) => {
      this.componentData = data;
    });
  }
}
